.toolbarButton {
	width: 32px;
	height: 32px;
	box-shadow: 0px 0px 7px -2px rgba(0, 0, 0, 0.12);
	border-radius: 8px;
	transition: box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	background: white;
	border: none;

	&:hover {
		box-shadow: 0px 0px 19px -2px rgba(0, 0, 0, 0.16);
	}

	&.active {
		box-shadow: 0px 0px 19px -2px rgba(0, 0, 0, 0.16);

		svg path {
			color: $activeColor;
		}
	}

	svg {
		width: 24px;
		height: 24px;

		path {
			color: $blackColor2;
		}
	}
}
